<div id="{{ createAttributeIdForConfigurator(attribute) }}" class="cx-row">
  <ng-container
    *ngIf="
      !config.features?.productConfiguratorAttributeTypesV2 &&
      (changedPrices$ | async) as changedPrices
    "
  >
    <div
      *ngFor="let value of attribute.values; let i = index"
      id="{{
        createAttributeValueIdForConfigurator(attribute, value.valueCode)
      }}"
      class="cx-configurator-select"
    >
      <input
        id="{{
          createAttributeValueIdForConfigurator(attribute, value.valueCode) +
            '-input'
        }}"
        type="checkbox"
        class="form-input"
        [value]="value.valueCode"
        [formControl]="attributeCheckBoxForms[i]"
        name="{{ createAttributeIdForConfigurator(attribute) }}"
        (click)="onSelect(i)"
        [attr.aria-label]="
          getAriaLabelGeneric(
            attribute,
            enrichValueWithPrice(value, changedPrices)
          )
        "
        [attr.aria-live]="
          isLastSelected(attribute.name, value.valueCode) ? 'polite' : null
        "
        [attr.aria-describedby]="createAttributeUiKey('label', attribute.name)"
        [attr.checked]="attributeCheckBoxForms[i].value ? 'checked' : null"
        [cxFocus]="{ key: attribute.name + '-' + value.name }"
      />
      <div class="cx-label-container">
        <label
          id="{{ createValueUiKey('label', attribute.name, value.valueCode) }}"
          for="{{
            createAttributeValueIdForConfigurator(attribute, value.valueCode) +
              '-input'
          }}"
          class="form-check-label"
        >
          <img
            *ngIf="getImage(value) as image"
            class="cx-img"
            src="{{ image?.url }}"
            alt="{{ image?.altText }}"
            title="{{ image?.altText }}"
          />
          <div *ngIf="!getImage(value)" class="cx-img-dummy"></div>
          {{ getLabel(expMode, value.valueDisplay, value.valueCode) }}
          <cx-configurator-price
            [formula]="
              extractValuePriceFormulaParameters(
                enrichValueWithPrice(value, changedPrices)
              )
            "
          ></cx-configurator-price>
        </label>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      config.features?.productConfiguratorAttributeTypesV2 &&
      (changedPrices$ | async) as changedPrices
    "
  >
    <ng-container *ngFor="let value of attribute.values; let i = index">
      <div
        *ngIf="isValueDisplayed(attribute, value)"
        id="{{
          createAttributeValueIdForConfigurator(attribute, value.valueCode)
        }}"
        class="cx-configurator-select"
      >
        <input
          id="{{
            createAttributeValueIdForConfigurator(attribute, value.valueCode) +
              '-input'
          }}"
          type="checkbox"
          class="form-input"
          [value]="value.valueCode"
          [formControl]="attributeCheckBoxForms[i]"
          name="{{ createAttributeIdForConfigurator(attribute) }}"
          (click)="!isReadOnly(attribute) && onSelect(i)"
          [attr.aria-label]="
            getAriaLabelGeneric(
              attribute,
              enrichValueWithPrice(value, changedPrices)
            )
          "
          [attr.aria-live]="
            isLastSelected(attribute.name, value.valueCode) ? 'polite' : null
          "
          [attr.aria-describedby]="
            createAttributeUiKey('label', attribute.name)
          "
          [attr.checked]="attributeCheckBoxForms[i].value ? 'checked' : null"
          [cxFocus]="{ key: attribute.name + '-' + value.name }"
        />
        <div class="cx-label-container">
          <label
            id="{{
              createValueUiKey('label', attribute.name, value.valueCode)
            }}"
            for="{{
              createAttributeValueIdForConfigurator(
                attribute,
                value.valueCode
              ) + '-input'
            }}"
            class="form-check-label"
            [style.cursor]="!isReadOnly(attribute) ? 'pointer' : 'default'"
          >
            <img
              *ngIf="getImage(value) as image"
              [ngClass]="getImgStyleClasses(attribute, value, 'cx-img')"
              src="{{ image?.url }}"
              alt="{{ image?.altText }}"
              title="{{ image?.altText }}"
            />
            <div
              *ngIf="!getImage(value)"
              [ngClass]="getImgStyleClasses(attribute, value, 'cx-img-dummy')"
            ></div>
            {{ getImageLabel(expMode, value.valueDisplay, value.valueCode) }}
            <button
              *ngIf="value.description"
              [cxPopover]="value.description"
              [cxPopoverOptions]="{
                placement: 'auto',
                class: 'cx-value-description',
                appendToBody: true,
                displayCloseButton: true,
              }"
              title="{{
                'configurator.a11y.description'
                  | cxTranslate
                    : {
                        value: getImageLabel(
                          expMode,
                          value.valueDisplay,
                          value.valueCode
                        ),
                      }
              }}"
              [attr.aria-label]="
                'configurator.a11y.description'
                  | cxTranslate
                    : {
                        value: getImageLabel(
                          expMode,
                          value.valueDisplay,
                          value.valueCode
                        ),
                      }
              "
            >
              <cx-icon [type]="iconTypes.INFO"></cx-icon>
            </button>
            <cx-configurator-price
              [formula]="
                extractValuePriceFormulaParameters(
                  enrichValueWithPrice(value, changedPrices)
                )
              "
            ></cx-configurator-price>
          </label>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
